interface HeroBannerProps {
  subtitle?: string;
}

export default function HeroBanner({ subtitle }: HeroBannerProps) {
  return (
    <div className="bg-primary-500 text-background-50 py-6 px-4 text-center relative overflow-hidden">
      <div className="absolute inset-0 bg-primary-600/20" />
      <div className="relative w-full max-w-xl mx-auto">
        <p className="text-xs text-primary-100 mb-1">李郡主更年期小屋</p>
        <h1 className="text-xl md:text-2xl font-heading font-semibold mb-1 flex items-center justify-center gap-2">
          <span>🌸</span>
          <span>健康信号自查表</span>
        </h1>
        <p className="text-xs text-primary-100">
          {subtitle || '专业版 · 适合想要深入了解自己身体状况的姐妹'}
        </p>
      </div>
    </div>
  );
}